export default "__VITE_ASSET__CbBW8pvs__"